import { AuthenticatedStorefrontAPIRequest } from 'components/discovery/shared/ecommerce-api-token/api/ecommerce-api-token-api.js'
import { ecommerceApiTokenStore } from 'components/discovery/shared/ecommerce-api-token/stores/ecommerce-api-token-store.js'

export class AuthenticatedRequestError extends Error {
  status: number

  constructor(status: number, endpointUrl: string) {
    super(`Request to ${endpointUrl} failed with status ${status}`)
    this.status = status
  }
}

export const fetchAuthenticated = async <T = unknown>(request: AuthenticatedStorefrontAPIRequest, body?: string): Promise<T> => {
  await ecommerceApiTokenStore.ensureToken(request.tokenEndpoint)
  const token = ecommerceApiTokenStore.token()
  request.headers = { ...request.headers, Authorization: `Bearer ${token ?? ''}` }

  const options: RequestInit = { method: request.method, headers: request.headers }
  if (body !== undefined) options.body = body

  const response = await fetch(request.endpointUrl, options)  // nosemgrep
  if (!response.ok) throw new AuthenticatedRequestError(response.status, request.endpointUrl)

  return response.json()
}
